"use client";

/**
 * @file LoginParticles.tsx
 * @description Partículas de fundo discretas e suaves para a tela de Login.
 */

import React from "react";
import { motion } from "motion/react";

const PARTICLE_COUNT = 50;
const particles = Array.from({ length: PARTICLE_COUNT });

export const LoginParticles = () => (
  <div className="absolute inset-0 pointer-events-none z-10">
    {particles.map((_, i) => {
      const left = Math.random() * 100;
      const top = Math.random() * 100;
      const delay = Math.random() * 2;
      const scale = Math.random() * 0.5 + 0.75;
      // Escolha de cor pode ser randomizada também
      return (
        <motion.div
          key={i}
          className="security-particle absolute rounded-full w-1 h-1 bg-blue-400/20"
          style={{ left: `${left}%`, top: `${top}%` }}
          animate={{
            x: [0, Math.random() * 100 - 50, 0],
            y: [0, Math.random() * 100 - 50, 0],
            scale: [1, scale, 1],
            opacity: [0.3, 0.6, 0.3],
          }}
          transition={{
            duration: 20,
            repeat: Infinity,
            repeatType: "reverse",
            delay,
            ease: "easeInOut",
          }}
        />
      );
    })}
  </div>
);
